export default __webpack_public_path__ + "static/NotoSerif-Italic-1e82b5d859a211c6890f12370b05749a.ttf";